<template>
  <div>
    <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
      <a-collapse
        :bordered="true"
        expand-icon-position="right"
        :activeKey="[
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
        ]"
        class="detail-collapse"
      >
        <!-- ===================== 项目基本信息 ===================== -->
        <a-collapse-panel key="1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                项目基本信息
              </div>
            </a-space>
          </template>
          <BasicInfo :form="form"></BasicInfo>
        </a-collapse-panel>

        <!-- ===================== 权证信息 ===================== -->
        <a-collapse-panel key="2">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">权证信息</div>
            </a-space>
          </template>
          <RightInfo :form="form"></RightInfo>
        </a-collapse-panel>

        <!-- ===================== 房源属性信息 ===================== -->
        <a-collapse-panel key="3">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源信息</div>
            </a-space>
          </template>
          <ResourceInfo :form="form"></ResourceInfo>
        </a-collapse-panel>

        <!-- ===================== 招租信息 ===================== -->
        <a-collapse-panel key="4">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">招租信息</div>
            </a-space>
          </template>
          <RentalInfo :form="form"></RentalInfo>
        </a-collapse-panel>

        <!-- ===================== 承租方需承担的其他费用 ===================== -->
        <a-collapse-panel key="5">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                承租方需承担的其他费用
              </div>
            </a-space>
          </template>
          <OtherCharges :form="form"></OtherCharges>
        </a-collapse-panel>

        <!-- ===================== 押金及租金支付要求 ===================== -->
        <a-collapse-panel key="6">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                押金及租金支付要求
              </div>
            </a-space>
          </template>
          <PaymentRequirement :form="form"></PaymentRequirement>
        </a-collapse-panel>

        <!-- ===================== 其他说明事项 ===================== -->
        <a-collapse-panel key="7">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                其他说明事项
              </div>
            </a-space>
          </template>
          <OtherDescription :form="form"></OtherDescription>
        </a-collapse-panel>

        <!-- ===================== 设置优先承租人 ===================== -->
        <a-collapse-panel key="8" v-if="form.hasPriorityLease == 1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                设置优先承租人
              </div>
            </a-space>
          </template>

          <PriorityLessee :form="form"></PriorityLessee>
        </a-collapse-panel>

        <!-- ===================== 保证金事项 ===================== -->
        <a-collapse-panel key="9">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">保证金事项</div>
            </a-space>
          </template>
          <Paybond :form="form"></Paybond>
        </a-collapse-panel>

        <!-- ===================== 承租资格条件 ===================== -->
        <a-collapse-panel key="10">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                承租资格条件
              </div>
            </a-space>
          </template>
          <Prerequisites :form="form"></Prerequisites>
        </a-collapse-panel>

        <!-- ===================== 公告时间 ===================== -->
        <a-collapse-panel key="11">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">公告时间</div>
            </a-space>
          </template>
          <AnnouncementTime :form="form"></AnnouncementTime>
        </a-collapse-panel>

        <!-- ===================== 招租流程 ===================== -->
        <a-collapse-panel key="12">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">招租流程</div>
            </a-space>
          </template>
          <LeaseProcess :form="form"></LeaseProcess>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（多次报价） ===================== -->
        <a-collapse-panel
          key="13"
          v-if="
            form.transactionModeType == 1 &&
            form.transactionMode == 1 &&
            form.onlineBiddingMode == 1
          "
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（多次报价）
              </div>
            </a-space>
          </template>
          <RepeatedOffer
            :form="form"
            :startingPrice="startingPrice"
          ></RepeatedOffer>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（一次报价） ===================== -->
        <a-collapse-panel
          key="14"
          v-if="
            form.transactionModeType == 1 &&
            form.transactionMode == 1 &&
            form.onlineBiddingMode == 2
          "
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（一次报价）
              </div>
            </a-space>
          </template>
          <OnceOffer :form="form" :startingPrice="startingPrice"></OnceOffer>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（开放报价） ===================== -->
        <a-collapse-panel
          key="15"
          v-if="form.transactionModeType == 1 && form.transactionMode == 5"
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（开放报价）
              </div>
            </a-space>
          </template>
          <OpenOffer :form="form" :startingPrice="startingPrice"></OpenOffer>
        </a-collapse-panel>

        <!-- ===================== 出租方信息 ===================== -->
        <a-collapse-panel key="16">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">出租方信息</div>
            </a-space>
          </template>
          <LessorInfo :form="form"></LessorInfo>
        </a-collapse-panel>

        <!-- ===================== 房源封面 ===================== -->
        <a-collapse-panel key="17">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源封面</div>
            </a-space>
          </template>

          <div>
            <a-upload
              action="https://api.jssyjt.net/gxs-property/alertRealEstate/addPropertyCertificate"
              list-type="picture-card"
              :file-list="propertyCertificate"
              @preview="handlePreview"
              @change="handlePropertyCertificateChange"
              :multiple="true"
              accept=".jpg,.png,.pdf"
              :data="{ propertyId: 98989898 }"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="previewHandleCancel"
            >
              <img alt="资产证照信息" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-collapse-panel>

        <!-- ===================== 房源图片 ===================== -->
        <a-collapse-panel key="18">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源图片</div>
            </a-space>
          </template>

          <div>
            <a-upload
              action="https://api.jssyjt.net/gxs-property/alertRealEstate/addPropertyCertificate"
              list-type="picture-card"
              :file-list="propertyCertificate"
              @preview="handlePreview"
              @change="handlePropertyCertificateChange"
              :multiple="true"
              accept=".jpg,.png,.pdf"
              :data="{ propertyId: 98989898 }"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="previewHandleCancel"
            >
              <img alt="资产证照信息" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-collapse-panel>

        <!-- ===================== 其他公示的附件（对外公示） ===================== -->
        <a-collapse-panel key="19">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                其他公示的附件（对外公示）
              </div>
            </a-space>
          </template>
          <PublicAttachement :form="form"></PublicAttachement>
        </a-collapse-panel>

        <!-- ===================== 上传附件 ===================== -->
        <a-collapse-panel key="20">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">上传附件</div>
            </a-space>
          </template>
          <a-table
            :columns="fileColumns"
            :data-source="form.fileList"
            :pagination="false"
            rowKey="id"
          >
            <template slot="file" slot-scope="text, record">
              <a :href="record.url" target="_blank">{{ record.name }}</a>
            </template>

            <template slot="action"> -- </template>
          </a-table>
        </a-collapse-panel>

        <!-- ===================== 材料补充清单 ===================== -->
        <a-collapse-panel key="21">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                材料补充清单
              </div>
            </a-space>
          </template>

          <a-row :gutter="24">
            <a-col :span="12" style="margin: 10px 0px">
              <a-button type="primary" @click="openVisable">新增</a-button>
            </a-col>
          </a-row>
          <a-table
            :columns="fileColumns"
            :data-source="form.fileList"
            :pagination="false"
            rowKey="id"
          >
            <template slot="file" slot-scope="text, record">
              <a :href="record.url" target="_blank">{{ record.name }}</a>
            </template>

            <template slot="action"> -- </template>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import BasicInfo from "./basicInfo/BasicInfo";
import RightInfo from "./rightInfo/RightInfo";
import ResourceInfo from "./resourceInfo/ResourceInfo";
import RentalInfo from "./rentalInfo/RentalInfo";
import OtherCharges from "./otherCharges/OtherCharges";
import PaymentRequirement from "./paymentRequirement/PaymentRequirement";
import OtherDescription from "./otherDescription/OtherDescription";
import PriorityLessee from "./priorityLessee/PriorityLessee";
import Paybond from "./paybond/Paybond";
import Prerequisites from "./prerequisites/Prerequisites";
import AnnouncementTime from "./announcementTime/AnnouncementTime";
import LeaseProcess from "./leaseProcess/LeaseProcess";
import RepeatedOffer from "./repeatedOffer/RepeatedOffer";
import OnceOffer from "./onceOffer/OnceOffer";
import OpenOffer from "./openOffer/OpenOffer";
import LessorInfo from "./lessorInfo/LessorInfo";

import PublicAttachement from "./publicAttachement/PublicAttachement";
export default {
  components: {
    BasicInfo,
    RightInfo,
    ResourceInfo,
    RentalInfo,
    OtherCharges,
    PaymentRequirement,
    OtherDescription,
    PriorityLessee,
    Paybond,
    Prerequisites,
    AnnouncementTime,
    LeaseProcess,
    RepeatedOffer,
    OnceOffer,
    OpenOffer,
    LessorInfo,
    PublicAttachement
  },
  computed: {
    startingPrice() {
      return Number(this.form.floorPrice) || 0;
    },
  },
  data() {
    return {
      previewVisible: false,
      propertyCertificate: [],
      previewImage: "",
      visible: false,
      form: {
        //项目基本信息
        projectId: "",
        projectName: "",
        stateIntentProject: 0,
        rentWay: 2,
        stateOwned: 1,
        onlineSignup: 1,
        //招租信息
        projectName: "",
        leaseTerm: undefined,
        leaseTermUnit: 1,
        floorPrice: undefined,
        floorPriceeUnit: 1,
        rentalPriceType: 1,
        rentalBasePriceDisclosureScope: 1,
        rentalBasePriceRangeMin: undefined,
        rentalBasePriceRangeMax: undefined,
        rentalBasePricePublicTime: 1,
        showRentalUnitPrice: 1,
        hasExistPricingBasis: 0,
        pricingBasis: 1,
        pricingBasisOther: "",
        rentCount: undefined,
        enterpriseFirstYearPricing: undefined,
        enterprisePricingUnit: 1,
        hasRentAdjustments: 0,
        rentAdjustmentWay: "",
        hasRentFreePeriod: 0,
        rentFreePeriod: undefined,
        rentFreePeriodUnit: 2,
        hasRentContainFreePeriod: 1,
        leaseType: [],
        rentalUse: [],
        rentalUseDesc: "",
        businessCategories: [],
        parkCategories: [],
        formatRequirements: "",
        policyRecommendations: "",
        currentSituationDecoration: 3,
        allowRemodeling: 0,
        remodelingDesc: "",
        parkingSpaceAvailable: 0,
        numberParkingSpaces: undefined,
        sublease: 0,
        subleaseDesc: "",
        //承租方需承担的其他费用
        hasPropertyManagementFee: 0,
        propertyManagementFeeWay: 1,
        propertyManagementFeeWayDesc: "",
        propertyManagementFee: undefined,
        propertyManagementFeeUnit: 1,
        utilityFee: 1,
        utilityFeeDesc: "",
        paymentSubject: 1,
        //押金及租金支付要求
        hasPayDeposit: 0,
        depositPayRequirement: "",
        rentPaymenclaim: 1,
        rentPaymenclaimDesc: "",
        //其他说明事项
        hasExistAbove: 0,
        mortgage: 0,
        rentalStatus: 1,
        leaseTermExpireTime: "",
        rentalStatusOtherDesc: "",
        otherRequirement: "",
        hasPriorityLease: 0,
        agencyRegistration: 0,
        //保证金事项
        hasPayBond: 1,
        hasPayBondByPriorityHolder: 1,
        bondAmountByPriorityHolder: undefined,
        bondAmount: undefined,
        bondPayDeadlineType: 2,
        otherBondDesc: "",
        //承租资格条件
        intentionLeaseRange: [],
        intentionLeaseRangeDesc: "",
        qualificationCondition:
          "1.意向承租方应具有良好的财务状况和支付能力；\n2.意向承租方应具有良好商业信用，无不良经营记录；\n3.符合国家法律、行政法规规定的其他条件。",
        supportingServices: [],
        //公告时间
        disclosureMethod: 1,
        disclosurePeriod: 10,
        disclosurePeriodExtend: 14,
        extendWorkingDaysForever: undefined,
        extendWorkingDaysNum: undefined,
        extendWorkingDaysNum: undefined,
        //招租流程
        transactionModeType: 1,
        transactionMode: 1,
        onlineBiddingMode: 1,
        hasQualificationAudit: 1,
        otherBidDesc: "",
        //竞价参数设置
        minimumIncrement: undefined,
        maximumIncrement: undefined,
        allowStartingQuote: 1,
        timedQuoteDuration: undefined,
        timedQuoteDurationUnit: 2,
        continuousQuoteDuration: undefined,
        continuousQuoteDurationUnit: 3,
        increment: undefined,
        //出租方信息
        hasEntrustRent: 1,
        lessorName: "",
        lessorType: 1,
        businessPrincipal: "",
        principalContactNumber: "",
        certType: 19,
        certNumber: "",
        legalPerson: "",
        registAddress: "",
        hasLessorStateOwned: 1,
        economicTypeLessor: undefined,
        groupDepartmentName: undefined,
        groupDepartmentCode: undefined,
        regulatoryAuthorities: undefined,
        regulatoryAuthoritiesCode: undefined,
        email: undefined,
        mailingAddress: undefined,
        personCertType: 0,
        personCertNumber: undefined,
        //其他公示的附件
        publicAttachement:[{
          id:1,
          type:"其他公示的附件",
          file:"www.baidu.com",
        }],
        //图片列表
        fileList: [],
      },
      rules: {
        projectName: [{ required: true, message: "请输入项目名称" }],
        stateIntentProject: [
          { required: true, message: "请选择是否关联意向发布" },
        ],
        rentWay: [{ required: true, message: "请选择出租方式" }],
        stateOwned: [{ required: true, message: "请选择是否为国资" }],
        onlineSignup: [{ required: true, message: "请选择是否在线报名" }],
        leaseTerm: [
          { required: true, message: "请输入租赁期限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入租赁期限");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("租赁期限必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        floorPrice: [
          {
            required: true,
            message: "请输入出租底价",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              // 1. 基础校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              const price = Number(value);
              if (price < 0) {
                return callback("出租底价必须大于等于0");
              }
              //必须是公示出租底价选项再判断是否落于区间
              if (this.form.rentalPriceType == 2) {
                // 2. 取得区间上下限
                const min = Number(this.form.rentalBasePriceRangeMin);
                const max = Number(this.form.rentalBasePriceRangeMax);

                // 3. 只有当上下限都合法时才进行区间判断
                if (!isNaN(min) && min > 0 && !isNaN(max) && max > 0) {
                  if (price < min) {
                    return callback(`出租底价不得低于区间下限（${min}）`);
                  }

                  if (price > max) {
                    return callback(`出租底价不得高于区间上限（${max}）`);
                  }
                }
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        rentalPriceType: [{ required: true, message: "请选择出租价格类型" }],
        rentalBasePriceDisclosureScope: [
          { required: true, message: "请选择出租底价公开范围" },
        ],
        rentalBasePriceRangeMin: [
          {
            required: true,
            message: "请输入出租底价价格区间（下限）",
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价价格区间（下限）");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("出租底价价格区间（下限）必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        rentalBasePriceRangeMax: [
          {
            required: true,
            message: "请输入出租底价价格区间（上限）",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              // 1. 基础校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价价格区间（上限）");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              const max = Number(value);
              if (max <= 0) {
                return callback("出租底价价格区间（上限）必须大于0");
              }

              // 2. 取下限价格
              const min = Number(this.form.rentalBasePriceRangeMin);

              // 3. 只有存在下限时，才进行 10 倍校验
              if (!isNaN(min) && min > 0) {
                if (max > min * 10) {
                  return callback("出租底价上限不得高于下限价格10倍");
                }

                if (max < min) {
                  return callback("区间价上限不得小于区间价下限");
                }
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        rentalBasePricePublicTime: [
          { required: true, message: "请选择出租底价公示时间" },
        ],
        showRentalUnitPrice: [
          { required: true, message: "请选择是否公告展示租金单价" },
        ],
        hasExistPricingBasis: [
          { required: true, message: "请选择是否存在定价依据" },
        ],
        pricingBasis: [{ required: true, message: "请选择定价依据说明" }],
        pricingBasisOther: [
          { required: true, message: "请输入定价依据其他说明" },
        ],
        hasRentAdjustments: [
          { required: true, message: "请选择是否涉及租金调整" },
        ],
        rentAdjustmentWay: [{ required: true, message: "请输入租金调整方式" }],
        hasRentFreePeriod: [{ required: true, message: "请选择是否有免租期" }],
        rentFreePeriod: [{ required: true, message: "请输入免租期时间" }],
        hasRentContainFreePeriod: [
          { required: true, message: "请选择租赁期限是否含免租期" },
        ],
        leaseType: [{ required: true, message: "请选择租赁类型" }],
        rentalUse: [{ required: true, message: "请选择租赁用途" }],
        rentalUseDesc: [{ required: true, message: "请输入租赁用途其他说明" }],
        businessCategories: [{ required: true, message: "请选择商业细分业态" }],
        parkCategories: [{ required: true, message: "请选择园区细分业态" }],
        formatRequirements: [{ required: true, message: "请输入业态要求" }],
        currentSituationDecoration: [
          { required: true, message: "请选择装修现状" },
        ],
        allowRemodeling: [{ required: true, message: "请选是否允许装修改造" }],
        remodelingDesc: [{ required: true, message: "请输入装修改造说明" }],
        parkingSpaceAvailable: [
          { required: true, message: "请选择是否有停车位" },
        ],
        numberParkingSpaces: [
          { required: true, message: "请输入停车位个数", trigger: "blur" },
        ],
        sublease: [{ required: true, message: "请选择是否可转租" }],
        hasPropertyManagementFee: [
          { required: true, message: "请选择是否有物业管理费" },
        ],
        propertyManagementFeeWay: [
          { required: true, message: "请选择物业管理费缴纳方式" },
        ],
        propertyManagementFeeWayDesc: [
          { required: true, message: "请输入物业管理费缴纳方式其他说明" },
        ],
        propertyManagementFee: [
          {
            required: true,
            message: "请输入物业管理费金额",
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入物业管理费金额");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("物业管理费金额必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        utilityFee: [{ required: true, message: "请选择水电气等费用支付情况" }],
        utilityFeeDesc: [
          { required: true, message: "请输入水电气等费用其他说明" },
        ],
        paymentSubject: [{ required: true, message: "请选择服务费付款主体" }],
        hasPayDeposit: [{ required: true, message: "请选择是否支付押金" }],
        depositPayRequirement: [
          { required: true, message: "请输入押金缴纳要求" },
        ],
        rentPaymenclaim: [{ required: true, message: "请选择租金支付要求" }],
        hasExistAbove: [{ required: true, message: "请选择是否存在以上情况" }],
        mortgage: [{ required: true, message: "请选择是否存抵押情况" }],
        rentalStatus: [{ required: true, message: "请选择房屋状态" }],
        leaseTermExpireTime: [
          { required: true, message: "请输入租赁期限届满时间" },
        ],
        rentalStatusOtherDesc: [
          { required: true, message: "请输入房屋状态其他说明" },
        ],
        hasPriorityLease: [
          { required: true, message: "请选择是否存在优先承租权人" },
        ],
        agencyRegistration: [{ required: true, message: "请选择是否代办登记" }],
        hasPayBond: [{ required: true, message: "请选择是否缴纳保证金" }],
        hasPayBondByPriorityHolder: [
          { required: true, message: "请选择优先承租权人交纳保证金" },
        ],
        bondAmountByPriorityHolder: [
          { required: true, message: "请输入差额保证金金额" },
        ],
        bondAmount: [{ required: true, message: "请输入保证金金额" }],
        bondPayDeadlineType: [
          { required: true, message: "请选择保证金缴纳截止时间" },
        ],
        intentionLeaseRange: [
          { required: true, message: "请选择意向承租方范围" },
        ],
        intentionLeaseRangeDesc: [
          { required: true, message: "请输入意向承租范围其他说明" },
        ],
        qualificationCondition: [
          { required: true, message: "请输入潜在承租方应具备的资格条件" },
        ],
        disclosureMethod: [{ required: true, message: "请选择公告披露方式" }],
        disclosurePeriod: [
          { required: true, message: "请输入公告发布期(工作日)" },
        ],
        disclosurePeriodExtend: [
          { required: true, message: "请选择披露期满未征集到意向方" },
        ],
        extendWorkingDaysForever: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 13) {
                if (!value) {
                  return callback("请输入延长工作日时间");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        extendWorkingDaysNum: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长工作日时间");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        extendedCyclesNumber: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长周期数");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        transactionModeType: [
          { required: true, message: "请选择招租方式类型" },
        ],
        transactionMode: [{ required: true, message: "请选择招租方式" }],
        onlineBiddingMode: [{ required: true, message: "请选择网络竞价模式" }],
        hasQualificationAudit: [
          {
            required: true,
            message: "请选择出租方是否对意向承租方进行资格审核",
          },
        ],
        otherBidDesc: [{ required: true, message: "请输入其他竞价说明" }],
        minimumIncrement: [
          { required: true, message: "请输入加价幅度" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入加价幅度");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("加价幅度必须为大于0的数字");
              }

              // 3️⃣ 如果存在起始价，则不能超过 5%
              if (startPrice) {
                const max = Number(startPrice) * 0.05;
                if (Number(value) > max) {
                  return callback(`加价幅度不能超过起始价的 5%`);
                }
              }

              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        maximumIncrement: [
          { required: true, message: "请输入最高加价倍数" },
          {
            validator: (rule, value, callback) => {
              // 1️⃣ 必填
              if (value === "" || value === null || value === undefined) {
                return callback("请输入最高加价倍数");
              }

              // 2️⃣ 必须是数字
              const num = Number(value);
              if (isNaN(num)) {
                return callback("请输入有效的数字");
              }

              // 3️⃣ 必须大于等于 1
              if (num < 1) {
                return callback("最高加价倍数必须大于 1");
              }

              // ✅ 校验通过
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        allowStartingQuote: [
          { required: true, message: "请选择是否允许以起始价报价" },
        ],
        timedQuoteDuration: [{ required: true, message: "请输入定时报价时长" }],
        timedQuoteDurationUnit: [
          { required: true, message: "请选择定时报价时长单位" },
        ],
        continuousQuoteDuration: [
          { required: true, message: "请输入连续报价周期" },
        ],
        continuousQuoteDurationUnit: [
          { required: true, message: "请选择连续报价周期单位" },
        ],
        increment: [
          { required: true, message: "请输入加价幅度" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入加价幅度");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("加价幅度必须为大于0的数字");
              }

              // 3️⃣ 如果存在起始价，则不能超过 5%
              if (startPrice) {
                const max = Number(startPrice) * 0.05;
                if (Number(value) > max) {
                  return callback(`加价幅度不能超过起始价的 5%`);
                }
              }

              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        hasEntrustRent: [
          { required: true, message: "请选择是否受委托进行招租" },
        ],
        lessorName: [{ required: true, message: "请输入出租方名称" }],
        lessorType: [{ required: true, message: "请选择出租方类型" }],
        businessPrincipal: [{ required: true, message: "请输入出租方联系人" }],
        principalContactNumber: [
          { required: true, message: "请输入出租方联系人电话" },
        ],
        certType: [{ required: true, message: "请选择出租方证件类别" }],
        certNumber: [{ required: true, message: "请输入出租方证件号码" }],
        legalPerson: [{ required: true, message: "请输入出租方法定代表人" }],
        country: [{ required: true, message: "请选择国家" }],
        registerProvince: [
          { required: true, message: "请选择请选择省/市/区（县）" },
        ],
        registAddress: [{ required: true, message: "请输入注册地（地址）" }],
        hasLessorStateOwned: [
          { required: true, message: "请选择出租方是否国资" },
        ],
        economicTypeLessor: [
          { required: true, message: "请选择出租方经济类型" },
        ],
        groupDepartmentName: [{ required: true, message: "请输入所属集团" }],
        groupDepartmentCode: [
          { required: true, message: "请输入所属集团统一社会信用代码" },
        ],
        regulatoryAuthorities: [{ required: true, message: "请输入监管部门" }],
        regulatoryAuthoritiesCode: [
          { required: true, message: "请输入监管部门统一社会信用代码" },
        ],
        email: [{ required: true, message: "请输入电子邮件" }],
        mailingAddress: [{ required: true, message: "请输入通讯地址" }],
        personCertType: [{ required: true, message: "请选择自然人证件类型" }],
        personCertNumber: [{ required: true, message: "请输入出租方证件号码" }],
      },

      fileColumns: [
        { title: "序号", dataIndex: "id", width: 80 },
        { title: "附件类型", dataIndex: "type" },
        {
          title: "附件信息",
          dataIndex: "file",
          scopedSlots: { customRender: "file" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },

  watch: {
    "form.disclosurePeriodExtend"(val) {
      this.$nextTick(() => {
        if (val === 13) {
          this.$refs.baseForm.validateField("extendWorkingDaysForever");
        } else {
          this.$refs.baseForm.clearValidate(["extendWorkingDaysForever"]);
        }
        if (val === 12) {
          this.$refs.baseForm.validateField([
            "extendWorkingDaysNum",
            "extendedCyclesNumber",
          ]);
        } else {
          this.$refs.baseForm.clearValidate([
            "extendWorkingDaysNum",
            "extendedCyclesNumber",
          ]);
        }
      });
    },
    "form.transactionModeType"(val) {
      this.syncQualificationAudit();
    },
    "form.transactionMode"(val) {
      this.syncQualificationAudit();
    },
  },

  methods: {
    //招租流程网络开放报价检测
    syncQualificationAudit() {
      if (
        this.form.transactionModeType === 1 &&
        this.form.transactionMode === 5
      ) {
        this.form.hasQualificationAudit = 0;
      }
    },
    previewHandleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      console.log(file);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handlePropertyCertificateChange({ fileList }) {
      console.log("营业执照图片变更", fileList);
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: item.response.data,
            };
          }
        } else {
          return item;
        }
      });
      this.propertyCertificate = fileList;
    },
    openVisable() {
      this.visible = true;
    },
    closeMoudle() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.detail-collapse /deep/ checkbox.ant-checkbox {
  height: 32px !important;
  border-radius: 4px;
}

::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 8px !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
